import logoutPlaceholder from '../../hooks/logoutPlaceholder.js';

const apiEndPoint = process.env.REACT_APP_FETCH_URL;

const getUserInfo = async ({ logout = logoutPlaceholder }) => {
    const response = await fetch(`${apiEndPoint}/api/info/user`, {
        mode: "cors",
        credentials: "include"
    });
    if(response.ok) {
        try {
            return await response.json();
        }
        catch (error) {
            throw new Error(`Failed parsing the user info: ${error}`);
        }
    }
    response.status === 401 && logout();
    throw new Error(`Could not load the user info: ${response.statusText}`);
};

export default getUserInfo;
